import { css } from 'styled-components';
import Color from 'color';
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';

export default function({
  size,
  link,
  color,
  ...props
}) {
  return css`
    display: inline-block;
    padding: .25rem .5rem;
    background-color: ${props.theme.accentColor};
    color: #fff;
    text-transform: uppercase;
    text-align: center;
    border: none;

    &[disabled],
    &:disabled {
      opacity: .6;
    }

    ${size === 'large' && css`
      min-width: 8rem;
      padding: .75rem 1.75rem;
    `}

    ${size === 'medium' && css`
      min-width: 6rem;
      padding: .5rem 1rem;
    `}

    ${link && css`
      background-color: transparent;
      color: #000;
    `};

    ${color === 'secondary' && css`
      background-color: ${Color(props.theme.accentColor).alpha(.88).toString()};
    `}
  `;
}
